export const INVESTOR_TYPE_COLORS = {
  "Angel Investor": "#3b82f6",
  "Venture Capitalist": "#14b8a6",
  "Corporate Investor": "#10b981",
  "Family Office": "#f59e0b",
  "HNI / Individual": "#8b5cf6",
  Other: "#94a3b8",
};

export const INVESTOR_TYPE_DUMMY = [
  { label: "Angel Investor", value: 34, color: "#3b82f6" },
  { label: "Venture Capitalist", value: 27, color: "#14b8a6" },
  { label: "Corporate Investor", value: 16, color: "#10b981" },
  { label: "Family Office", value: 13, color: "#f59e0b" },
  { label: "HNI / Individual", value: 10, color: "#8b5cf6" },
];

export const INVESTOR_TYPE_DESCS = {
  "Angel Investor": "Early-stage, high-conviction backers",
  "Venture Capitalist": "Institutional fund-led growth capital",
  "Corporate Investor": "Strategic alignment and sector funding",
  "Family Office": "Patient capital with long-term horizon",
  "HNI / Individual": "High-net-worth individual investors",
};

export const TECH_CATEGORY_COLORS = {
  AgriTech: "#10b981",
  BioTech: "#14b8a6",
  CleanTech: "#22c55e",
  DeepTech: "#3b82f6",
  EdTech: "#f59e0b",
  HealthTech: "#ef4444",
  InfoTech: "#8b5cf6",
  MedTech: "#ec4899",
  Manufacturing: "#f97316",
  Other: "#94a3b8",
};

export const TECH_SECTOR_DUMMY = [
  { label: "DeepTech", value: 28, color: "#3b82f6" },
  { label: "HealthTech", value: 19, color: "#ef4444" },
  { label: "AgriTech", value: 14, color: "#10b981" },
  { label: "InfoTech", value: 11, color: "#8b5cf6" },
  { label: "CleanTech", value: 10, color: "#22c55e" },
  { label: "EdTech", value: 8, color: "#f59e0b" },
  { label: "Other", value: 10, color: "#94a3b8" },
];

export const TECH_SECTOR_DESCS = {
  DeepTech: "Core scientific & engineering breakthroughs",
  HealthTech: "Patient care, diagnostics & wellness",
  AgriTech: "Farming, food & supply chain innovation",
  InfoTech: "Software, SaaS & digital platforms",
  CleanTech: "Sustainability, energy & environment",
  EdTech: "Learning systems & skill development",
  Other: "Cross-domain & emerging categories",
};
